import firebase from 'firebase/compat/app'
import "firebase/firestore";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/analytics";

let firebaseConfig = JSON.parse(process.env.VUE_APP_FIREBASE)

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const analytics = firebase.analytics();

// Get the service worker registration
if(navigator.serviceWorker) {
    navigator.serviceWorker.ready.then(function (registration) {
        // Pass the Firebase configuration to the service worker
        registration.active.postMessage({ type: 'firebaseConfig', config: JSON.parse(process.env.VUE_APP_FIREBASE) });
    }).catch((error) => {
        console.error('ServiceWorker registration failed: ', error);
    });
}